import React from 'react';

// reference: https://designportal.microsoft.com/media/?resetsearch=&field=metaproperty_Asset_Type&value=Illustrations&viewType=grid#
export const CloudCheckmark = (props) => (
  <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M451.831 228.309C435.052 208.057 410.192 194.732 382.24 193.32C376.76 172.54 365.45 153.44 349.1 137.81C325.84 115.57 295.51 103.32 263.7 103.32C231.89 103.32 201.56 115.57 178.3 137.81C161.98 153.42 150.68 172.48 145.19 193.22C92.6702 194.18 50.2402 237.21 50.2402 289.96C50.2402 302.995 52.8311 315.436 57.5249 326.795L118.582 314.584C112.966 308.212 109.467 299.968 109.25 290.87C108.75 269.64 125.87 252.21 147.05 252.21L188.24 252.13C194.94 252.11 200.37 246.67 200.37 239.97V222.66C200.37 189.96 229.37 162.33 263.7 162.33C298.03 162.33 327.03 189.95 327.03 222.66V239.96C327.03 246.67 332.46 252.1 339.16 252.12L377.31 252.21C390.576 252.21 402.264 259.087 408.998 269.462L451.831 228.309Z"
      fill="#E7E7E7"
    />
    <path
      d="M451.831 228.309C435.052 208.057 410.192 194.732 382.24 193.32C376.76 172.54 365.45 153.44 349.1 137.81C325.84 115.57 295.51 103.32 263.7 103.32C231.89 103.32 201.56 115.57 178.3 137.81C161.98 153.42 150.68 172.48 145.19 193.22C92.6702 194.18 50.2402 237.21 50.2402 289.96C50.2402 302.995 52.8311 315.436 57.5249 326.795L118.582 314.584C112.966 308.212 109.467 299.968 109.25 290.87C108.75 269.64 125.87 252.21 147.05 252.21L188.24 252.13C194.94 252.11 200.37 246.67 200.37 239.97V222.66C200.37 189.96 229.37 162.33 263.7 162.33C298.03 162.33 327.03 189.95 327.03 222.66V239.96C327.03 246.67 332.46 252.1 339.16 252.12L377.31 252.21C390.576 252.21 402.264 259.087 408.998 269.462L451.831 228.309Z"
      fill="url(#paint0_radial_3062_1357)"
    />
    <path
      d="M451.831 228.309C435.052 208.057 410.192 194.732 382.24 193.32C376.76 172.54 365.45 153.44 349.1 137.81C325.84 115.57 295.51 103.32 263.7 103.32C231.89 103.32 201.56 115.57 178.3 137.81C161.98 153.42 150.68 172.48 145.19 193.22C92.6702 194.18 50.2402 237.21 50.2402 289.96C50.2402 302.995 52.8311 315.436 57.5249 326.795L118.582 314.584C112.966 308.212 109.467 299.968 109.25 290.87C108.75 269.64 125.87 252.21 147.05 252.21L188.24 252.13C194.94 252.11 200.37 246.67 200.37 239.97V222.66C200.37 189.96 229.37 162.33 263.7 162.33C298.03 162.33 327.03 189.95 327.03 222.66V239.96C327.03 246.67 332.46 252.1 339.16 252.12L377.31 252.21C390.576 252.21 402.264 259.087 408.998 269.462L451.831 228.309Z"
      fill="url(#paint1_radial_3062_1357)"
      fillOpacity="0.8"
    />
    <path
      d="M451.831 228.309C435.052 208.057 410.192 194.732 382.24 193.32C376.76 172.54 365.45 153.44 349.1 137.81C325.84 115.57 295.51 103.32 263.7 103.32C231.89 103.32 201.56 115.57 178.3 137.81C161.98 153.42 150.68 172.48 145.19 193.22C92.6702 194.18 50.2402 237.21 50.2402 289.96C50.2402 302.995 52.8311 315.436 57.5249 326.795L118.582 314.584C112.966 308.212 109.467 299.968 109.25 290.87C108.75 269.64 125.87 252.21 147.05 252.21L188.24 252.13C194.94 252.11 200.37 246.67 200.37 239.97V222.66C200.37 189.96 229.37 162.33 263.7 162.33C298.03 162.33 327.03 189.95 327.03 222.66V239.96C327.03 246.67 332.46 252.1 339.16 252.12L377.31 252.21C390.576 252.21 402.264 259.087 408.998 269.462L451.831 228.309Z"
      fill="url(#paint2_radial_3062_1357)"
      fillOpacity="0.8"
    />
    <path
      d="M451.831 228.309C435.052 208.057 410.192 194.732 382.24 193.32C376.76 172.54 365.45 153.44 349.1 137.81C325.84 115.57 295.51 103.32 263.7 103.32C231.89 103.32 201.56 115.57 178.3 137.81C161.98 153.42 150.68 172.48 145.19 193.22C92.6702 194.18 50.2402 237.21 50.2402 289.96C50.2402 302.995 52.8311 315.436 57.5249 326.795L118.582 314.584C112.966 308.212 109.467 299.968 109.25 290.87C108.75 269.64 125.87 252.21 147.05 252.21L188.24 252.13C194.94 252.11 200.37 246.67 200.37 239.97V222.66C200.37 189.96 229.37 162.33 263.7 162.33C298.03 162.33 327.03 189.95 327.03 222.66V239.96C327.03 246.67 332.46 252.1 339.16 252.12L377.31 252.21C390.576 252.21 402.264 259.087 408.998 269.462L451.831 228.309Z"
      fill="url(#paint3_radial_3062_1357)"
      fillOpacity="0.8"
    />
    <path
      d="M443.454 219.397C438.041 213.488 430.261 209.783 421.617 209.783C405.264 209.783 392.008 223.039 392.008 239.392C392.008 247.544 395.302 254.927 400.633 260.281L400.627 260.288C400.647 260.304 400.667 260.319 400.687 260.335C401.6 261.248 402.573 262.102 403.599 262.89C410.867 269.95 415.31 279.902 415.052 290.869C414.562 311.479 397.222 327.709 376.602 327.709H147.702C127.082 327.709 109.742 311.479 109.252 290.869C108.908 276.245 116.923 263.425 128.868 256.862L95.0306 208.371C68.12 225.573 50.2422 255.718 50.2422 289.959C50.2422 343.309 93.6422 386.709 146.992 386.709H377.312C430.662 386.709 474.062 343.299 474.062 289.949C474.062 262.153 462.283 237.06 443.454 219.397Z"
      fill="url(#paint4_linear_3062_1357)"
    />
    <path
      d="M443.454 219.397C438.041 213.488 430.261 209.783 421.617 209.783C405.264 209.783 392.008 223.039 392.008 239.392C392.008 247.544 395.302 254.927 400.633 260.281L400.627 260.288C400.647 260.304 400.667 260.319 400.687 260.335C401.6 261.248 402.573 262.102 403.599 262.89C410.867 269.95 415.31 279.902 415.052 290.869C414.562 311.479 397.222 327.709 376.602 327.709H147.702C127.082 327.709 109.742 311.479 109.252 290.869C108.908 276.245 116.923 263.425 128.868 256.862L95.0306 208.371C68.12 225.573 50.2422 255.718 50.2422 289.959C50.2422 343.309 93.6422 386.709 146.992 386.709H377.312C430.662 386.709 474.062 343.299 474.062 289.949C474.062 262.153 462.283 237.06 443.454 219.397Z"
      fill="url(#paint5_radial_3062_1357)"
    />
    <path
      d="M443.454 219.397C438.041 213.488 430.261 209.783 421.617 209.783C405.264 209.783 392.008 223.039 392.008 239.392C392.008 247.544 395.302 254.927 400.633 260.281L400.627 260.288C400.647 260.304 400.667 260.319 400.687 260.335C401.6 261.248 402.573 262.102 403.599 262.89C410.867 269.95 415.31 279.902 415.052 290.869C414.562 311.479 397.222 327.709 376.602 327.709H147.702C127.082 327.709 109.742 311.479 109.252 290.869C108.908 276.245 116.923 263.425 128.868 256.862L95.0306 208.371C68.12 225.573 50.2422 255.718 50.2422 289.959C50.2422 343.309 93.6422 386.709 146.992 386.709H377.312C430.662 386.709 474.062 343.299 474.062 289.949C474.062 262.153 462.283 237.06 443.454 219.397Z"
      fill="url(#paint6_radial_3062_1357)"
    />
    <path
      d="M443.454 219.397C438.041 213.488 430.261 209.783 421.617 209.783C405.264 209.783 392.008 223.039 392.008 239.392C392.008 247.544 395.302 254.927 400.633 260.281L400.627 260.288C400.647 260.304 400.667 260.319 400.687 260.335C401.6 261.248 402.573 262.102 403.599 262.89C410.867 269.95 415.31 279.902 415.052 290.869C414.562 311.479 397.222 327.709 376.602 327.709H147.702C127.082 327.709 109.742 311.479 109.252 290.869C108.908 276.245 116.923 263.425 128.868 256.862L95.0306 208.371C68.12 225.573 50.2422 255.718 50.2422 289.959C50.2422 343.309 93.6422 386.709 146.992 386.709H377.312C430.662 386.709 474.062 343.299 474.062 289.949C474.062 262.153 462.283 237.06 443.454 219.397Z"
      fill="url(#paint7_radial_3062_1357)"
      fillOpacity="0.4"
    />
    <path
      d="M443.454 219.397C438.041 213.488 430.261 209.783 421.617 209.783C405.264 209.783 392.008 223.039 392.008 239.392C392.008 247.544 395.302 254.927 400.633 260.281L400.627 260.288C400.647 260.304 400.667 260.319 400.687 260.335C401.6 261.248 402.573 262.102 403.599 262.89C410.867 269.95 415.31 279.902 415.052 290.869C414.562 311.479 397.222 327.709 376.602 327.709H147.702C127.082 327.709 109.742 311.479 109.252 290.869C108.908 276.245 116.923 263.425 128.868 256.862L95.0306 208.371C68.12 225.573 50.2422 255.718 50.2422 289.959C50.2422 343.309 93.6422 386.709 146.992 386.709H377.312C430.662 386.709 474.062 343.299 474.062 289.949C474.062 262.153 462.283 237.06 443.454 219.397Z"
      fill="url(#paint8_radial_3062_1357)"
    />
    <path
      d="M443.454 219.397C438.041 213.488 430.261 209.783 421.617 209.783C405.264 209.783 392.008 223.039 392.008 239.392C392.008 247.544 395.302 254.927 400.633 260.281L400.627 260.288C400.647 260.304 400.667 260.319 400.687 260.335C401.6 261.248 402.573 262.102 403.599 262.89C410.867 269.95 415.31 279.902 415.052 290.869C414.562 311.479 397.222 327.709 376.602 327.709H147.702C127.082 327.709 109.742 311.479 109.252 290.869C108.908 276.245 116.923 263.425 128.868 256.862L95.0306 208.371C68.12 225.573 50.2422 255.718 50.2422 289.959C50.2422 343.309 93.6422 386.709 146.992 386.709H377.312C430.662 386.709 474.062 343.299 474.062 289.949C474.062 262.153 462.283 237.06 443.454 219.397Z"
      fill="url(#paint9_radial_3062_1357)"
      fillOpacity="0.8"
    />
    <path
      d="M443.454 219.397C438.041 213.488 430.261 209.783 421.617 209.783C405.264 209.783 392.008 223.039 392.008 239.392C392.008 247.544 395.302 254.927 400.633 260.281L400.627 260.288C400.647 260.304 400.667 260.319 400.687 260.335C401.6 261.248 402.573 262.102 403.599 262.89C410.867 269.95 415.31 279.902 415.052 290.869C414.562 311.479 397.222 327.709 376.602 327.709H147.702C127.082 327.709 109.742 311.479 109.252 290.869C108.908 276.245 116.923 263.425 128.868 256.862L95.0306 208.371C68.12 225.573 50.2422 255.718 50.2422 289.959C50.2422 343.309 93.6422 386.709 146.992 386.709H377.312C430.662 386.709 474.062 343.299 474.062 289.949C474.062 262.153 462.283 237.06 443.454 219.397Z"
      fill="url(#paint10_radial_3062_1357)"
      fillOpacity="0.8"
    />
    <circle
      cx="423.109"
      cy="240.885"
      r="22.3906"
      fill="url(#paint11_radial_3062_1357)"
    />
    <circle
      cx="423.109"
      cy="240.885"
      r="22.3906"
      fill="url(#paint12_radial_3062_1357)"
      fillOpacity="0.8"
    />
    <path
      d="M259.004 292.708C258.763 292.994 258.5 293.284 258.224 293.554C252.913 298.868 244.297 298.868 238.985 293.554L214.171 268.734C208.86 263.422 208.86 254.812 214.171 249.498C219.483 244.186 228.087 244.186 233.399 249.498L244.553 260.653C245.848 261.947 247.999 261.755 249.043 260.25L278.725 217.476C280.767 214.534 283.761 212.646 286.996 211.941C290.553 211.166 294.419 211.815 297.654 214.055C303.826 218.337 305.352 226.809 301.073 232.981L261.551 289.943C260.817 291.004 259.957 291.928 259.004 292.708Z"
      fill="#4ECBFF"
    />
    <path
      d="M259.004 292.708C258.763 292.994 258.5 293.284 258.224 293.554C252.913 298.868 244.297 298.868 238.985 293.554L214.171 268.734C208.86 263.422 208.86 254.812 214.171 249.498C219.483 244.186 228.087 244.186 233.399 249.498L244.553 260.653C245.848 261.947 247.999 261.755 249.043 260.25L278.725 217.476C280.767 214.534 283.761 212.646 286.996 211.941C290.553 211.166 294.419 211.815 297.654 214.055C303.826 218.337 305.352 226.809 301.073 232.981L261.551 289.943C260.817 291.004 259.957 291.928 259.004 292.708Z"
      fill="url(#paint13_linear_3062_1357)"
    />
    <path
      d="M259.004 292.708C258.763 292.994 258.5 293.284 258.224 293.554C252.913 298.868 244.297 298.868 238.985 293.554L214.171 268.734C208.86 263.422 208.86 254.812 214.171 249.498C219.483 244.186 228.087 244.186 233.399 249.498L244.553 260.653C245.848 261.947 247.999 261.755 249.043 260.25L278.725 217.476C280.767 214.534 283.761 212.646 286.996 211.941C290.553 211.166 294.419 211.815 297.654 214.055C303.826 218.337 305.352 226.809 301.073 232.981L261.551 289.943C260.817 291.004 259.957 291.928 259.004 292.708Z"
      fill="url(#paint14_linear_3062_1357)"
    />
    <path
      d="M259.004 292.708C258.763 292.994 258.5 293.284 258.224 293.554C252.913 298.868 244.297 298.868 238.985 293.554L214.171 268.734C208.86 263.422 208.86 254.812 214.171 249.498C219.483 244.186 228.087 244.186 233.399 249.498L244.553 260.653C245.848 261.947 247.999 261.755 249.043 260.25L278.725 217.476C280.767 214.534 283.761 212.646 286.996 211.941C290.553 211.166 294.419 211.815 297.654 214.055C303.826 218.337 305.352 226.809 301.073 232.981L261.551 289.943C260.817 291.004 259.957 291.928 259.004 292.708Z"
      fill="url(#paint15_linear_3062_1357)"
    />
    <path
      d="M259.004 292.708C258.763 292.994 258.5 293.284 258.224 293.554C252.913 298.868 244.297 298.868 238.985 293.554L214.171 268.734C208.86 263.422 208.86 254.812 214.171 249.498C219.483 244.186 228.087 244.186 233.399 249.498L244.553 260.653C245.848 261.947 247.999 261.755 249.043 260.25L278.725 217.476C280.767 214.534 283.761 212.646 286.996 211.941C290.553 211.166 294.419 211.815 297.654 214.055C303.826 218.337 305.352 226.809 301.073 232.981L261.551 289.943C260.817 291.004 259.957 291.928 259.004 292.708Z"
      fill="url(#paint16_radial_3062_1357)"
      fillOpacity="0.62"
    />
    <path
      d="M259.004 292.708C258.763 292.994 258.5 293.284 258.224 293.554C252.913 298.868 244.297 298.868 238.985 293.554L214.171 268.734C208.86 263.422 208.86 254.812 214.171 249.498C219.483 244.186 228.087 244.186 233.399 249.498L244.553 260.653C245.848 261.947 247.999 261.755 249.043 260.25L278.725 217.476C280.767 214.534 283.761 212.646 286.996 211.941C290.553 211.166 294.419 211.815 297.654 214.055C303.826 218.337 305.352 226.809 301.073 232.981L261.551 289.943C260.817 291.004 259.957 291.928 259.004 292.708Z"
      fill="url(#paint17_radial_3062_1357)"
      fillOpacity="0.6"
    />
    <path
      d="M259.004 292.708C258.763 292.994 258.5 293.284 258.224 293.554C252.913 298.868 244.297 298.868 238.985 293.554L214.171 268.734C208.86 263.422 208.86 254.812 214.171 249.498C219.483 244.186 228.087 244.186 233.399 249.498L244.553 260.653C245.848 261.947 247.999 261.755 249.043 260.25L278.725 217.476C280.767 214.534 283.761 212.646 286.996 211.941C290.553 211.166 294.419 211.815 297.654 214.055C303.826 218.337 305.352 226.809 301.073 232.981L261.551 289.943C260.817 291.004 259.957 291.928 259.004 292.708Z"
      fill="url(#paint18_radial_3062_1357)"
      fillOpacity="0.8"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(231.757 285.251) rotate(13.5829) scale(176.896 190.766)"
      >
        <stop offset="0.75002" stopColor="#E8E8E8" stopOpacity="0" />
        <stop offset="0.894078" stopColor="#D0D0D0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(55.4512 189) rotate(93.6361) scale(82.1654 229.223)"
      >
        <stop offset="0.358207" stopColor="#D0D0D0" />
        <stop offset="0.588983" stopColor="#E8E8E8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(212.451 244) rotate(-143.455) scale(105.802 58.6002)"
      >
        <stop offset="0.180275" stopColor="#D0D0D0" />
        <stop offset="0.588983" stopColor="#E8E8E8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(417.451 241) rotate(103.055) scale(70.8308 91.6692)"
      >
        <stop offset="0.495615" stopColor="#E7E7E7" />
        <stop offset="0.588983" stopColor="#E8E8E8" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_3062_1357"
        x1="448.002"
        y1="245.014"
        x2="88.1856"
        y2="431.567"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.208333" stopColor="#4FCCFF" />
        <stop offset="0.423515" stopColor="#90D700" />
        <stop offset="0.833393" stopColor="#E2FA98" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(117.502 228.499) rotate(127.983) scale(138.926 143.096)"
      >
        <stop offset="0.402541" stopColor="#E7E7E7" />
        <stop offset="1" stopColor="#E7E7E7" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(262.152 326.999) rotate(180) scale(158.15 39)"
      >
        <stop offset="0.24443" stopColor="#7CB600" />
        <stop offset="0.927083" stopColor="#8ECC07" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(398 208.371) rotate(45.7273) scale(146.116 82.2423)"
      >
        <stop offset="0.46258" stopColor="#0069E3" />
        <stop offset="1" stopColor="#0069E3" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(420.002 257.499) rotate(98.5691) scale(36.9121 20.3008)"
      >
        <stop offset="0.618589" stopColor="#006FC9" />
        <stop offset="1" stopColor="#1F80CE" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(179 427.994) rotate(-35.2865) scale(354.523 290.668)"
      >
        <stop offset="0.870822" stopColor="#1F80CE" stopOpacity="0" />
        <stop offset="0.9413" stopColor="#0162B0" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.45142 190) rotate(63.132) scale(190.292 699.95)"
      >
        <stop offset="0.377939" stopColor="#CFD2D4" />
        <stop offset="0.495475" stopColor="#E8E8E8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(427.911 231.219) rotate(120.18) scale(45.8556)"
      >
        <stop offset="0.05" stopColor="#E8CCFF" />
        <stop offset="0.23" stopColor="#C594FF" />
        <stop offset="0.36" stopColor="#AD6CFF" />
        <stop offset="0.51" stopColor="#8E42FF" />
        <stop offset="0.78" stopColor="#E0538F" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(423.108 240.903) rotate(97.82) scale(39.7483)"
      >
        <stop offset="0.45" stopColor="white" stopOpacity="0" />
        <stop offset="0.84" stopColor="white" />
      </radialGradient>
      <linearGradient
        id="paint13_linear_3062_1357"
        x1="229.185"
        y1="289.183"
        x2="248.567"
        y2="269.312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4ECBFF" />
        <stop offset="0.276128" stopColor="#0070DB" />
        <stop offset="0.529185" stopColor="#0083F5" stopOpacity="0.315315" />
        <stop offset="0.77314" stopColor="#4ECBFF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_3062_1357"
        x1="212.384"
        y1="260.934"
        x2="224.119"
        y2="266.506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007EEC" />
        <stop offset="1" stopColor="#2F9EFF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_3062_1357"
        x1="264.891"
        y1="281.265"
        x2="249.481"
        y2="270.446"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0070DB" />
        <stop offset="0.484391" stopColor="#0083F5" stopOpacity="0.428977" />
        <stop offset="0.592846" stopColor="#0083F5" stopOpacity="0.236848" />
        <stop offset="1" stopColor="#4ECBFF" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint16_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(231.204 254.584) rotate(38.6109) scale(18.0876 6.56738)"
      >
        <stop stopColor="white" />
        <stop offset="0.395833" stopColor="white" stopOpacity="0.458333" />
        <stop offset="0.98096" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(239.281 264.036) rotate(-136.655) scale(22.4635 8.55525)"
      >
        <stop stopColor="#BCF2FF" />
        <stop offset="0.447917" stopColor="#BCF2FF" stopOpacity="0.442708" />
        <stop offset="1" stopColor="#BCF2FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_3062_1357"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(275.776 229.105) rotate(128.653) scale(26.9632 10.5005)"
      >
        <stop stopColor="#BCF2FF" />
        <stop offset="0.541007" stopColor="#BCF2FF" stopOpacity="0.458333" />
        <stop offset="1" stopColor="#BCF2FF" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

CloudCheckmark.displayName = 'CloudCheckmark';
